<template>
  <div class="box">
    <el-input v-model="num" class="controlDisabledInput" ref="readonlyInput" disabled size="mini"> </el-input>
    <i
      :class="{ 'el-icon-circle-plus': true, 'disabled-el-icon-circle-plus': this.disabled }"
      size="20"
      @click="changeNum"
    ></i>
  </div>
</template>
<script>
export default {
  props: {
    modelValue: {
      type: Number | String,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    modelValue: {
      handler(newV) {
        this.num = window.tool.deepClone(newV);
        // if (this.$refs.readonlyInput) {
        //   this.$refs.readonlyInput.value = this.num;
        // }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      num: 0
    };
  },
  methods: {
    changeNum() {
      if (!this.disabled) {
        this.$emit("changeNum");
      }
    }
  }
};
</script>
<style lang="scss">
.controlDisabledInput {
  width: 50px !important;
}
.controlDisabledInput .el-input__inner {
  height: 20px;
  font-size: 12px;
  text-align: center;
}
</style>
<style lang="scss" scoped>
.box {
  display: flex;
  align-items: center;
}
.el-icon-circle-plus {
  font-size: 20px;
  cursor: pointer;
  color: rgb(232, 79, 71);
}
.disabled-el-icon-circle-plus {
  cursor: not-allowed;
  color: #999;
}
</style>
